import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useAnnualEnrollmentInfo } from '../../../pages/annual-enrollment/hooks/useAnnualEnrollmentInfo';
import { AnnualEnrollmentState } from '../../../pages/annual-enrollment/models/annual-enrollment-models';
import { TcsmStates } from '../../../root/tcsm-model';
import { getLetterMonthDate } from '../../helpers/date-helpers';
import { replaceAll } from '../../helpers/string-helpers';
import { useQuery } from '../../hooks/useQuery';
import { useSystemState } from '../../hooks/useSystemState';
import { DemographicsContext } from '../../models/demographics-model';
import { TcsmAnnualEnrollmentMessageBlock } from '../../models/tcsm-block-models';
import { ContentSpacer } from '../layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../wysiwyg-with-react-link';

enum Status {
	Active = 'Active',
	Closed = 'Closed',
}

interface Props {
	blockData: TcsmAnnualEnrollmentMessageBlock,
}

export function TcsmAnnualEnrollmentMessageBlockView(props: Props) {

	const { blockData } = props;
	const app = useContext(DemographicsContext);
	const messages = blockData?.messages;
	const AELoaded = useAnnualEnrollmentInfo(app, false, true);
	const currentCycleState = useSystemState();
	const AEState = useSelector<TcsmStates, AnnualEnrollmentState>(state => state.annualEnrollment[app]);
	const today = currentCycleState?.base_cycle_date ? new Date(currentCycleState.base_cycle_date) : new Date();
	const query = useQuery()?.get('status');
	function IsAnnualEnrollmentMemberOpen() {
		return AEState?.AEInfo?.ae_status?.first_enrollment_allowed && today > new Date(AEState?.AEInfo?.ae_status?.first_enrollment_allowed);
	}

	function IsAnnualEnrollmentMemberAlreadyClosed() {
		return AEState?.AEInfo?.ae_status?.last_enrollment_allowed && today > new Date(AEState?.AEInfo?.ae_status?.last_enrollment_allowed);
	}

	if (!AELoaded) {
		return null;
	}

	function getMessage() {
		if (IsAnnualEnrollmentMemberOpen() && (query && query !== Status.Active)) {

			return messages.filter(m => m.annualEnrollmentStatus === Status.Active)[0]?.message;
		}
		if (IsAnnualEnrollmentMemberAlreadyClosed() || (query === Status.Closed)) {
			return messages.filter(m => m.annualEnrollmentStatus === Status.Closed)[0]?.message;
		}
		return messages.filter(m => m.annualEnrollmentStatus === Status.Active)[0]?.message;
	}

	return (
		<section className='adage-block'>
			<ContentSpacer>
				<WysiwygWithReactLink content={replaceAll(getMessage(), '{AeEnrollmentEndDate}', getLetterMonthDate(AEState?.AEInfo?.ae_status?.last_enrollment_allowed_nominal))} />
			</ContentSpacer>
		</section>
	);
}

export default TcsmAnnualEnrollmentMessageBlockView;
